<template>
  <div>
    <div
      v-if="crossItems.length > 0"
      v-stick-in-parent
      data-sticky-container="#item-container"
    >
      <hr>
      <div class="cross-selling-wrapper mt-2">
        <p class="title">
          {{ $translate("PerformanceWheels::Template.crossSellingAccessoryTitle") }}<!--
          --><span class="ml-2">{{ $translate("PerformanceWheels::Template.crossSellingAccessoryTitleDescription") }}</span>
        </p>

        <div class="cross-selling-row row no-gutters">
          <div
            v-for="crossItm in crossItems"
            :key="crossItm.data.variation.itemId"
            class="col-12 col-sm-6 col-lg-12"
          >
            <popper v-cloak placement="left" class="popper d-inline-flex align-self-center pr-2">
              <template #handle>
                <button class="btn btn-icon btn-secondary btn-sm p-2">
                  <i class="fa fa-info"></i>
                </button>
              </template>
              <template #content>
                {{ crossItm.data.texts.shortDescription }}
              </template>
            </popper>

            <article
              class="cmp cmp-product-thumb h-100_X mb-0 p-0 accessory-item cross-item"
              :data-item-id="crossItm.data.variation.itemId"
              :data-price="crossItm.data.prices.default.unitPrice.value"
              :data-variation-id="crossItm.data.variation.id"
              :class="{ 'cross-item-active' : crossSellingItems.includes(crossItm.data.variation.id) }"
              @click.prevent="toggleCrossSellingItem(crossItm.data.variation.id, $event.target)"
            >
              <div
                v-if="hasItemTooltip(crossItm)"
                v-tooltip
                class="cross-tooltip"
                data-toggle="tooltip"
                data-placement="top"
                :title="crossItm.data.texts.shortDescription"
              />

              <div class="thumb-inner d-flex flex-sm-column_X h-100">
                <!--is depracted macro function-->
                <!--{{ AddToBasket.printTwigComponent(crossItm, true, false) }}-->

                <div class="thumb-image col-3 col-sm-4">
                  <img
                    v-if="hasItemImage(crossItm)"
                    :src="crossItm.data.images.all[0].urlMiddle"
                    :alt="crossItm.data.texts.name1"
                  >
                </div>

                <!-- ITEM DETAILS -->
                <!--<slot name="item-details">-->
                <div class="thumb-content d-flex flex-column col-9 col-sm-8">
                  <div class="name">
                    {{ crossItm.data.texts.name1 }}
                    <span class="unitNumber">{{ crossItm.data.texts.name2 }}</span>
                  </div>
                  <div class="prices d-flex align-items-end">
                    <div class="price text-color-primary ml-auto">
                      + {{ crossItm.data.prices.default.unitPrice.formatted }}
                    </div>
                  </div>
                </div>
                <!--</slot>-->
                <!-- ./ITEM DETAILS  -->
              </div>
            </article>
          </div> <!-- end for -->
        </div>
      </div>
    </div>

    <div class="single-item-bottom cross-selling-bottom">
      <div class="container-max">
        <div class="d-md-flex my-3">
          <div class="d-flex_mt-2_ w-100 _container-fluid">
            <div class="single-price-basket _w-100 d-flex row no-gutters">
              <div
                v-if="!!currentVariation.filter && currentVariation.filter.isSalable"
                class="order-2 additional-content-after-add-to-basket gtm-single-amazon align-self-center col-6 col-lg-3 text-right text-lg-left"
              >
                <!--<slot name="before-add-to-basket"></slot>-->
                <!-- Amazon -->
                <div class="amzPayButton-custom">
                  <img
                    v-if="lang == 'de'"
                    height="45"
                    width="200"
                    :src="pluginPathCw+'/images/payment/amazon_express_de.png'"
                    alt="Amazon-Button"
                    @click="addToBasketPaymentButton(currentVariation.variation.id, false)"
                  >
                  <img
                    v-else
                    height="45"
                    width="200"
                    :src="pluginPathCw+'/images/payment/amazon_express_en.png'"
                    alt="Amazon-Button"
                    @click="addToBasketPaymentButton(currentVariation.variation.id, false)"
                  >
                </div>
              </div>

              <div
                v-if="currentVariation.variation.itemType === 'set'"
                class="col-12 alert_alert-info"
              >
                {{ $translate("Ceres::Template.singleItemSetInfo") }}
              </div>
              <div
                v-else
                class="order-1 order-lg-3 btn-basket col-12 col-lg-6 ml-auto mb-2 mb-lg-0 "
              >
                <div
                  v-if="!!currentVariation.filter && currentVariation.filter.isSalable"
                  class="row"
                >
                  <div
                    id="cw-price"
                    class="single-detail-price text-right text-nowrap mr-4 mb-2 mb-sm-0 pr-0 col"
                  >
                    <item-price
                      :show-cross-price="isRecommendedPriceActive"
                      class="mb-0"
                    />

                    <div class="vat small text-muted text-nowrap mb-0">
                      <span>{{ $translate(getTxtSingleItemVat) }}</span>
                      <span>{{ $translate("Ceres::Template.singleItemExclusive") }}</span>
                      <a
                        v-if="hasShippingCostsCategoryId"
                        data-toggle="modal"
                        href="#shippingscosts"
                        :title="$translate('Ceres::Template.singleItemShippingCosts')"
                      >{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
                      <a
                        v-else
                        :title="$translate('Ceres::Template.singleItemShippingCosts')"
                      >{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 ml-auto btn-group">
                    <!--<button class="btn btn-block btn-primary btn-appearance" @click="addToBasket(itemData.variation.id)" >-->
                    <button
                      class="btn btn-block btn-primary btn-appearance"
                      :disabled="isLoading"
                      @click="addToBasket(currentVariation.variation.id)"
                    >
                      {{ $translate("Ceres::Template.singleItemAddToBasket") }}
                    </button>
                  </div>
                </div>
                <div
                  v-else
                  class="gtm-single-consultation"
                >
                  <a
                    data-toggle="modal"
                    href="#consultation"
                    :disabled="isLoading"
                    class="btn btn-outline-primary p-4 w-100"
                  >
                    <!--<svg-->
                    <!--width="34"-->
                    <!--height="34"-->
                    <!--&gt;-->
                    <!--<use-->
                    <!--xlink:href="#svg_contact"-->
                    <!--xmlns:xlink="https://www.w3.org/1999/xlink"-->
                    <!--/>-->
                    <!--</svg>-->
                    <span>{{ $translate("PerformanceWheels::Template.singleItemBtnRequest") }}</span>
                  </a>
                </div>
              </div>

              <div
                v-if="!!currentVariation.filter && currentVariation.filter.isSalable"
                class="order-1 col-6 col-lg-3 gtm-single-paypal align-self-center"
              >
                <!--<slot name="after-add-to-basket"></slot>-->
                <!--PayPal-->
                <div id="ppButton">
                  <a
                    rel="nofollow"
                    style="cursor: pointer"
                    @click="addToBasketPaymentButton(currentVariation.variation.id, true)"
                  >
                    <img
                      v-if="lang == 'de'"
                      height="32"
                      width="170"
                      :src="pluginPathCw+'/images/payment/paypal_express_de.png'"
                      alt="Paypal-Button"
                    >
                    <img
                      v-else
                      height="32"
                      width="170"
                      :src="pluginPathCw+'/images/payment/paypal_express_en.png'"
                      alt="Paypal-Button"
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import NotificationService from 'ceres/app/services/NotificationService'
// const NotificationService = require('ceres/app/services/NotificationService') // AddToBasket.vue from Ceres
// import NotificationService from '../../services/NotificationService'

// import NotificationService from '../../../../../../../Ceres/resources/js/src/app/services/NotificationService'
// import TranslationService from '../../../../../../../Ceres/resources/js/src/app/services/TranslationService'
// import ExceptionMap from '../../../../../../../Ceres/resources/js/src/app/exceptions/ExceptionMap'

// const NotificationService = require('../../../../../../../Ceres/resources/js/src/app/services/NotificationService')
// import ExceptionMap from '../../exceptions/ExceptionMap'
import ExceptionMap from '../../../../../../../Ceres/resources/js/src/app/exceptions/ExceptionMap'

// eslint-disable-next-line no-unused-vars
// import TranslationService from '../../services/TranslationService'

export default {
  name: 'ItemCrossSelling',
  delimiters: ['${', '}'],

  provide () {
    return {
      itemId: this.$props.itemId
    }
  },

  props: {
    sourceTemplate: {
      type: String,
      default: 'single-item'
    },
    itemId: {
      type: Number,
      required: true
    },
    crossItemsData: {
      type: Array,
      required: true
    },
    showNetPrices: {
      type: Boolean,
      default: false
    }
  },

  jsonDataFields: [
    'itemDataRef',
    'crossItemsDataRef'
  ],

  data () {
    return {
      isLoading: false,
      crossSellingItems: [],
      crossItems: []
    }
  },

  computed: {

    notificationService () {
      return window.NotificationService
    },
    pluginPathCw () {
      // "publicPathCw": "{{ plugin_path('PerformanceWheels') ~ '/js/dist/' }}",
      // "pluginPathCw": "{{ plugin_path('PerformanceWheels') }}",
      return App.pluginPathCw
    },
    publicPath () {
      // "publicPath": "{{ plugin_path('Ceres') ~ '/js/dist/' }}",
      return App.publicPath
    },

    itemConfig () {
      return App.config.item.itemData
    },
    lang () {
      return App.language
    },
    currentVariation () {
      return this.$parent.currentVariation
      // return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },
    variationId () {
      return this.currentVariation.variation.id
    },
    isRecommendedPriceActive () {
      return App.config.item.itemData.includes('item.recommendedPrice') || App.config.item.itemData.includes('all')
    },
    isCrossItemShortDescription (cross) {
      return !cross.data.texts.shortDescription
    },
    hasShippingCostsCategoryId () {
      return App.config.global.shippingCostsCategoryId > 0
    },
    getTxtSingleItemVat () {
      return this.showNetPrices ? 'Ceres::Template.singleItemExclVAT' : 'Ceres::Template.singleItemInclVAT'
    },
    variationTotalPrice () {
      //          if (!this.item.prices.default.price.value) {
      //              return this.$store.getters[`${this.itemId}/variationTotalPrice`];
      //          }
      //          return this.item.prices.default.price.value;
      return this.$store.getters[`${this.itemId}/variationTotalPrice`]
    },
    itemPriceEur () {
      return this.$options.filters.currency(
        this.combinedPrice,
        this.currentVariation.prices.default.currency
      )
    },
    combinedPrice () {
      if (this.crossSellingItems.length === 0) {
        return this.variationTotalPrice
      }
      const crossPriceArray = this.crossSellingItems.map(varID => {
        const item = this.crossItems.find(itm => itm !== null ? itm.data.variation.id === varID : false)

        return item.data.prices.default.price.value
      })
      const crossPrice = crossPriceArray.reduce((acc, current) => acc + current)

      return this.variationTotalPrice + crossPrice
    }

    //    itemPriceFormatted () {
    //      return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.combinedPrice, 'unitPrice', 'formatted')
    //    },
  },

  mounted () {
    //    console.log('mounted - XXXXXXXXXXXXXXXX', this)
    //    console.log(App)
    //    console.log(window)

    this.$nextTick(() => {
      //                this.$store.dispatch("addLastSeenItem", this.currentVariation.variation.id);
      //                this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
      //                    itemId:             this.itemId,
      //                    attributes:         this.attributesData,
      //                    variations:         this.variations,
      //                    initialVariationId: this.currentVariation.variation.id,
      //                    isPleaseSelectOption: this.initPleaseSelectOption,
      //                    afterKey:           this.afterKey
      //                });
      //
      //                if (this.isItemSet)
      //                {
      //                    this.$store.dispatch("initSetComponents", this.itemData);
      //                }
      //
      //                if (this.$slots.contact.length > 0){
      //                    this.$nextTick(() =>$('[data-toggle="popover"]').popover());
      //                }
      //
      //                const url = window.location.href.split("?");

      this.loadCrossItems()
      this.loadBasketPreview()
      this.setPriveInView()
    })
  },

  methods: {
    loadCrossItems () {
      if (!this.itemId) return
      this.crossItems = []
      this.crossItems = this.crossItemsData
    },

    loadBasketPreview () {
      this.$store.dispatch('loadComponent', 'basket-preview')
    },

    setPriveInView () {
      $('#cw-price .price span').html(this.itemPriceEur)
    },

    hasItemTooltip (crossItem) {
      return !!crossItem.data.texts.shortDescription
    },

    hasItemImage (crossItem) {
      return crossItem.data.images && crossItem.data.images.all[0] && crossItem.data.images.all[0].urlMiddle
    },

    toggleCrossSellingItem (crossId, target) {
      target = target || null

      if (this.crossSellingItems.includes(crossId)) {
        this.crossSellingItems = this.crossSellingItems.filter(item => item !== crossId)
      } else {
        this.crossSellingItems = [...this.crossSellingItems, crossId]
      }

      if (target !== null) {
        if (this.isMobile) {
          $(target).tooltip('toggle')
        }
      }
      this.setPriveInView()
    },
    getExceptionString (error) {
      const exceptionName = ExceptionMap.get(error.data.exceptionCode.toString())
      if (exceptionName) return 'Ceres::Template.' + exceptionName

      return 'PerformanceWheels::Template.errorBasketItemDefault'
    },
    addVarToBasket (varId) {
      const basketObj = {
        basketItemOrderParams: [],
        //        quantity: 1,
        quantity: (this.$store.state.basket.items.find(variations => variations.variationId === varId)) ? 0 : 1,
        template: 'Ceres::Basket.Basket',
        templateEvent: 'tpl.item',
        variationId: varId
      }

      return this.$store.dispatch('addBasketItem', basketObj)
    },

    addToBasket (articleVarId) {
      //      this.isLoading = true
      $('body').addClass('loading')

      //      this.$store.dispatch('loadComponent', 'basket-preview')
      this.addVarToBasket(articleVarId).then(() => {
        const basketObj = {
          basketItemOrderParams: [],
          quantity: 1,
          template: 'Ceres::Basket.Basket',
          templateEvent: 'tpl.item',
          variationId: articleVarId
        }
        document.dispatchEvent(new CustomEvent('afterBasketItemAdded', { detail: basketObj }))

        if (this.crossSellingItems.length > 0) {
          return Promise.all(this.crossSellingItems.map(varId => this.addVarToBasket(varId)
          ))
        }
        return Promise.resolve()
      })
      //        .then(() => window.location.href = window.location.origin + App.language === 'de' ? '/basket' : '/' + App.language + '/basket'
        .then(() => {
          window.location.href = window.location.origin + App.language === 'de' ? '/basket' : '/' + App.language + '/basket'
        })
        .catch(error => {
          //          console.log(error)
          this.isLoading = false

          if (error.data) {
            this.notificationService.error(
              this.$translate(this.getExceptionString(error), error.data.placeholder)
            ).closeAfter(5000)
          }
        })

      //                    .then(() => window.location.href = window.location.origin + App.language === "de" ? "/basket" : `/${App.language}/basket`)
      //                    .catch(error =>
      //                {
      //                    console.log(error);
      //                    this.isLoading = false;
      //
      //                    if (error.data)
      //                    {
      //                        NotificationService.error(
      //                            TranslationService.translate(
      //                                "Ceres::Template." + ExceptionMap.get(error.data.exceptionCode.toString())
      //                            )
      //                        ).closeAfter(5000);
      //                    }
      //                });
    },
    addToBasketPaymentButton (articleVarId, isPaypal) {
      //      this.isLoading = true
      $('body').addClass('loading')

      this.addVarToBasket(articleVarId).then(() => {
        if (this.crossSellingItems.length > 0) {
          //          console.log('hasCrossseller')
          return Promise.all(this.crossSellingItems.map(varId => this.addVarToBasket(varId)))
        }
        //        console.log('beforePromise')
        return Promise.resolve()
      }).then(
        response => {
          //          console.log('then')
          this.$store.commit('setIsAddToBasketLoading', 0)
          if (isPaypal) {
            window.doPaypalExpressCheckout($(this))
            //            console.log(document.querySelectorAll('[id^="ppButton"]')[0])
            //            console.log(document.querySelectorAll('[id^="ppButton"] > a')[0])
            //            document.querySelectorAll('[id^="ppButton"] > a')[0].click()
          } else {
            document.querySelectorAll('[id^="OffAmazonPaymentsWidgets"]')[0].click()
          }
        }
      ).catch(error => {
        //        console.log(error)
        //        this.isLoading = false
        $('body').removeClass('loading')

        if (error.data) {
          //                        NotificationService.error(
          //                            TranslationService.translate(
          //                                "Ceres::Template." + ExceptionMap.get(error.data.exceptionCode.toString())
          //                            )
          //                        ).closeAfter(5000);
          //          this.notificationService.error(
          //            ceresTranslate(
          //              this.getExceptionString(error.data.exceptionCode.toString()), error.data.placeholder
          //            )
          //          ).closeAfter(5000)

          this.notificationService.error(
            this.$translate(this.getExceptionString(error), error.data.placeholder)
          ).closeAfter(5000)
        }
      })
    }
  }
}
</script>
